import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { mdmsApi } from '@/api/mdmsApi';

/**
 * Store del MDM seleccionado en el header del panel.
 * Persiste en localStorage Y en BD (via set-default endpoint).
 */
interface MdmContextState {
  currentMdmId: number | null;
  currentMdmName: string | null;
  setMdm: (id: number, name: string, persistServer?: boolean) => void;
  clear: () => void;
}

export const useMdmContextStore = create<MdmContextState>()(
  persist(
    (set) => ({
      currentMdmId: null,
      currentMdmName: null,
      setMdm: (id, name, persistServer = true) => {
        set({ currentMdmId: id, currentMdmName: name });
        if (persistServer) {
          mdmsApi.setDefault(id).catch(() => {
            // Fallo silencioso — localStorage ya tiene el valor
          });
        }
      },
      clear: () => set({ currentMdmId: null, currentMdmName: null }),
    }),
    {
      name: 'mdm-context-store',
    },
  ),
);
